import TransferringRequests from './transferringRequestsContainer';

export default TransferringRequests;
